import { ExpandMore } from '@mui/icons-material'
import {
  Avatar,
  Button,
  Divider,
  ListItemAvatar,
  ListItemText,
  ListSubheader,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material'
import I18n from 'i18n-js'
import { useEffect, useState } from 'react'

import historyRef from '@src/lib/history'
import LinkChild from '@src/lib/LinkChild'
import useCurrentAuth from '@src/lib/useCurrentAuth'
import useCurrentRetailerAccount from '@src/lib/useCurrentRetailerAccount'

import LegacySvg from '../LegacySvg'

const BusinessSelectDropdown: React.FC = () => {
  const { retailerAccounts } = useCurrentAuth()
  const { ensureCurrentRetailerAccount } = useCurrentRetailerAccount()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const hasMultipleRetailerAccounts = retailerAccounts.length > 1

  useEffect(() => {
    const stopListening = historyRef.instance().listen(() => {
      setAnchorEl(null)
    })

    return stopListening
  }, [])

  return (
    <>
      <div style={{ flex: '0 1 auto', display: 'flex', minWidth: '5rem' }}>
        <Button
          onClick={
            hasMultipleRetailerAccounts
              ? (event) => {
                  setAnchorEl(event.currentTarget)
                }
              : undefined
          }
          color="inherit"
          endIcon={
            hasMultipleRetailerAccounts ? (
              <ExpandMore data-testid={`RetailerAccountDropdown-Expand`} />
            ) : undefined
          }
          aria-haspopup="true"
          aria-controls={`RetailerAccountDropdown-Popover`}
          data-testid={`RetailerAccountDropdown-Brand`}
        >
          <Typography noWrap>{ensureCurrentRetailerAccount.name}</Typography>
        </Button>
      </div>

      <Menu
        id={`RetailerAccountDropdown-Popover`}
        open={open}
        anchorEl={anchorEl}
        MenuListProps={{
          autoFocus: true,
        }}
        onClose={() => {
          setAnchorEl(null)
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        slotProps={{
          paper: {
            style: {
              width: 320,
            },
          },
        }}
      >
        <ListSubheader aria-disabled="true" disableSticky component="div">
          {I18n.t('nav.selectABusiness')}
        </ListSubheader>

        <Divider />

        {retailerAccounts.map((x) => {
          return (
            <LinkChild
              to={window.location.pathname.replaceAll(
                ensureCurrentRetailerAccount.slug || '',
                x.slug || '',
              )}
              key={x.id}
            >
              <MenuItem
                divider
                selected={ensureCurrentRetailerAccount.slug === x.slug}
                component="a"
              >
                <ListItemAvatar>
                  <Avatar
                    variant={'square'}
                    style={{ backgroundColor: 'transparent' }}
                  >
                    {x.logo_thumbnail_url ? (
                      <img
                        alt={x.name || ''}
                        src={x.logo_thumbnail_url}
                        style={{
                          width: '100%',
                          height: '3rem',
                          objectFit: 'contain',
                          verticalAlign: 'middle',
                        }}
                      />
                    ) : (
                      <LegacySvg
                        height={'30px'}
                        width={'30px'}
                        symbol={'retailer-house'}
                      />
                    )}
                  </Avatar>
                </ListItemAvatar>

                <ListItemText
                  primary={x.name}
                  primaryTypographyProps={{ noWrap: true }}
                />
              </MenuItem>
            </LinkChild>
          )
        })}
      </Menu>
    </>
  )
}

export default BusinessSelectDropdown
